import * as angular from 'angular';
import { IPromise } from 'angular';
import * as _ from 'underscore';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { RetailerService } from '../api/retailer.service';
import { AnalyticsFilter, VisitsAnalyticsFilter } from '../core';
import { IAnaliticsData, IAnalyticsListItem } from './../model/IAnaliticsData';

export interface ICollectedAnalyticsData {
    total: number;
    label: string;
    data: number[][];
    selected: boolean;
    color: string;
}

export interface IAnalyticsfilter {
    startDate: number;
    endDate: number;
    breakdown: string;
}

export class AnalyticsService {
    public static $inject = ['http', '$filter', 'retailerService', '$translate'];
    private dateFilter: (input: string) => string;
    constructor(
        private http: HttpService,
        private $filter: ng.IFilterService,
        private retailerService: RetailerService,
        public $translate: angular.translate.ITranslateService
    ) {
        this.dateFilter = $filter('serverDate');
    }

    public getStoreCampaignAnalytics(id: number, filter: AnalyticsFilter | IAnalyticsfilter): IPromise<ICollectedAnalyticsData[]> {
        return this.http.get<IAnaliticsData>(this.retailerService.storeCampaignAnalytics(id), this.getFilter(filter)).then((data) => this.convertFromAnaliticsData(data));
    }

    public getStoreVisitsAnalytics(id: number, filter: VisitsAnalyticsFilter | IAnalyticsfilter): IPromise<ICollectedAnalyticsData[]> {
        return this.http.get<IAnaliticsData>(this.retailerService.storeVisitsAnalytics(id), this.getFilter(filter)).then((data) => this.convertFromAnaliticsData(data));
    }

    public getCampaignAnalytics(id: number, filter: AnalyticsFilter | IAnalyticsfilter): IPromise<ICollectedAnalyticsData[]> {
        return this.http.get<IAnaliticsData>(this.retailerService.campaignAnalytics(id), this.getFilter(filter)).then((data) => this.convertFromAnaliticsData(data));
    }

    public getStoreImpressionAnalytics(id: number, filter: AnalyticsFilter | IAnalyticsfilter): IPromise<ICollectedAnalyticsData[]> {
        return this.http.get<IAnalyticsListItem[]>(this.retailerService.storeImpressionAnalytics(id), this.getFilter(filter)).then(this.convertFromListItemsData);
    }

    private convertFromAnaliticsData(data: IAnaliticsData): ICollectedAnalyticsData[] {
        return _.pairs(data.Summary).map((pair) => {
            const key = pair[0] as string;
            const total = pair[1];
            const keyTranslate = `${key.toLowerCase().replace(' ', '_')}_label`;
            const keyLabel = this.$translate.instant(keyTranslate);
            return {
                total,
                label: keyTranslate === keyLabel ? key : keyLabel,
                data: data.Data.map((item) => {
                    return [new Date(item.Date.toString()).getTime(), item.Values[key]];
                }),
                color: null,
                selected: false
            } as ICollectedAnalyticsData;
        });
    }

    private convertFromListItemsData(data: IAnalyticsListItem[]): ICollectedAnalyticsData[] {
        return _.pairs(data[0].Values).map((pair) => {
            const key = pair[0];
            const total = _.reduce(data, (subtotal, item: any) => {
                return subtotal + item.Values[key];
            }, 0);
            return {
                total,
                label: key,
                data: data.map((item) => {
                    return [new Date(item.Date.toString()).getTime(), item.Values[key]];
                }),
                color: null,
                selected: false
            } as ICollectedAnalyticsData;
        });
    }

    private getFilter(filter: {}) {
        return {
            params: _.object(_.map(filter, (value: string, key: string) => {
                if (key === 'startDate' || key === 'endDate') {
                    value = (new Date(value)).toISOString();
                }
                return [key, value];
            }))
        };
    }
}
angular
    .module('naut')
    .service('analyticsService', AnalyticsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/analytics.service.ts